import {useCallback, useState} from 'react';

import {saveAuthMsDynamicsCredentials} from 'src/openapi/admin/apis/MsDynamicsControllerApi';
import {useAppDispatch} from 'src/store/hooks';
import {getError} from 'src/utils/get-error';

import {LocalStorage} from '@pb/kit-util-client-storage';


import {getConnectionErrorMessage} from '../../utils/getDuplicatesErrorMessage';

type Props = {
    onSuccess: () => void,
    onFailure: (error: string) => void,
};

export const useSaveMsDynamicsAuth = ({onSuccess, onFailure}: Props) => {
    const apiDispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const action = useCallback(async (actionProps: {authorizationCode: string}) => {
        setIsLoading(true);
        const {authorizationCode} = actionProps;
        const authParams = LocalStorage.get('ms-dynamics-auth-credentials') as {accountId: number, nonce: string, state: string} | null;

        if (authParams) {
            const saveAuthResponse = await apiDispatch(saveAuthMsDynamicsCredentials({
                accountId: authParams.accountId,
                saveAuthMsDynamicsCredentialsRequest: {
                    nonce: authParams.nonce,
                    state: authParams.state,
                    authorizationCode,
                },
            }));
            if (saveAuthResponse.payload.success && saveAuthResponse.payload.data.type?.code === 'dup') {
                onFailure(getConnectionErrorMessage(saveAuthResponse.payload.data));
            } else if (saveAuthResponse.payload.success) {
                onSuccess();
            } else {
                onFailure(getError({error: saveAuthResponse.payload.data, separator: ' '}));
            }
        }
        setIsLoading(false);
    }, [onSuccess, onFailure, apiDispatch]);

    return {isLoading, action};
};
